import store from '..';
import { Eft } from '../../models';
import { Efts, SioBridge } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const {
    initialState,
    getReducer, listReducer, updateReducer,
    getAction, listAction, updateAction
} = createRestSlices(Efts);

initialState.isForgetting = false;
initialState.successfullyForgot = false;
initialState.failedToForget = false;

const RESET = 'kronos/efts/RESET';
const LOADING_EFTS_SUCCESS = 'kronos/efts/LOADING_ITEMS_SUCCESS';
const FORGET = 'kronos/efts/FORGET';
const FORGET_SUCCEEDED = 'kronos/efts/FORGET_SUCCEEDED';
const FORGET_FAILED = 'kronos/efts/FORGET_FAILED';
const forgetReducer = (state = initialState, action) => {
    switch(action.type) {
        case RESET:
            return {
                ...state,
                efts: [],
                eft: null,
                isForgetting: false,
                successfullyForgot: false,
                failedToForget: false,
            };
        case LOADING_EFTS_SUCCESS:
            return {
                ...state,
                isForgetting: false,
                successfullyForgot: false,
                failedToForget: false,
            };
        case FORGET:
            return {
                ...state,
                isForgetting: true,
                successfullyForgot: false,
                failedToForget: false,
            };
        case FORGET_SUCCEEDED:
            return {
                ...state,
                isForgetting: false,
                successfullyForgot: true,
                failedToForget: false,
            };
        case FORGET_FAILED:
            return {
                ...state,
                isLoadingOne: false,
                isForgetting: false,
                successfullyForgot: false,
                failedToForget: true,
            };
        default:
            return state;
    }
};

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        getReducer, listReducer, updateReducer,
        forgetReducer
    ]);
}

/* Export actions */
export const loadEft   = getAction;
export const loadEfts  = listAction;
export const updateEft = updateAction;

export const resetEfts = () => dispatch => dispatch({ type: RESET });

export const forgetEft = (eft, callback) => dispatch => {
    dispatch({ type: FORGET });
    Efts.forget(eft)
        .then(result => {
            dispatch({
                type: FORGET_SUCCEEDED,
                result
            });
            callback && callback(/*err*/null, result);
        }).catch(error => {
            dispatch({
                type: FORGET_FAILED,
                error
            });
            callback && callback(error);
        });
}

SioBridge.on('efts_update', (data) => {
    let connectedEfts = data.map(eft => new Eft(eft));

    const storeEfts = (store.getState().efts.efts || []).map(eft => {
        eft.status = 'disconnected';
        connectedEfts.forEach(connectedEft => {
            if (connectedEft._id === eft._id) {
                eft.status = 'connected';
                connectedEfts = connectedEfts.filter(connectedEft => connectedEft._id !== eft._id);
            }
        });

        return eft;
    });
    const efts = storeEfts.concat(connectedEfts);
    store.dispatch({
        type: 'kronos/efts/LOADING_ITEMS_SUCCESS',
        efts
    });
});
